import React from 'react'
import { Input } from './ui/Forms';


export default function RecipeIngredientEdit(props) {
    const {recipeIngredientList,
            handleIngredientChange,
            removeIngredient,
            index} = props;
  return (
    <>
            <div className='flex flex-row space-x-2'>
               <Input
                name="name"
                type="text"
                value= {recipeIngredientList[index].name}
                onChange={handleIngredientChange(index)}
                />
           
            
                <Input
                name="amount"
                type="text"
                value={recipeIngredientList[index].amount}
                onChange={handleIngredientChange(index)}
                />
        
            
                <p className="text-orange-200 hover:text-orange-100 font-bold py-2 px-1 text-2xl cursor-pointer"
                   onClick={()=>removeIngredient(index)}>
                    &times;
                </p>
            </div>
    </>
  )
}
